export class textData {
    public link: String;
    public button: String;
    public background: String;
    public typelink: String;
    public enlace: String;
    public viewMode: boolean;
    public title: String;
    public sub_title: String;
    public text: String;
    public text_roll: String;
    public typeMedia: String;
    public uploadStatus: String;
    public mediaUrl: any;
    public mediaImageSize: String;

    //EFFECTS

    public titleEffect: String;
    public subTitleEffect: String;
    public textEffect: String;
    public enlaceEffect: String;
    public mediaEffect: String;

    //PAGINACIÓN

    public pages: number;

}